import { breakpoints } from '@src/constants/breakpoints'
import { Interpolation, css } from 'styled-components'
import { ModalPosition } from './Modal'

export const dialogOverlayInnerDictionary: {
  [key in ModalPosition]: Interpolation<any>
} = {
  LEFT: css`
    left: 0;
    top: 0;

    // The pattern of using 2 heights vh and dvh means use 100vh as a fallback (for old browsers), then override with 100dvh where supported
    height: 100vh;
    height: 100dvh;
    border-radius: 0px 0px 8px 0px;

    @media (min-width: ${breakpoints.tablet}px) {
      min-width: 430px;
      width: fit-content;
      max-width: 565px;
    }

    @media (min-width: ${breakpoints.desktop}px) {
      width: fit-content;
      max-width: 565px;
    }
  `,
  RIGHT: css`
    right: 0;
    top: 0;
    height: 100vh;
    height: 100dvh;

    @media (min-width: ${breakpoints.tablet}px) {
      width: 565px;
    }

    @media (min-width: ${breakpoints.desktop}px) {
      width: 645px;
    }
  `,
  CENTER: css`
    padding: 10pt;
    height: 90vh;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 5px;
    width: 80%;

    @media (min-width: ${breakpoints.tablet}px) {
      width: 616px;
      padding: 0px;
    }

    @media (min-width: ${breakpoints.desktop}px) {
      height: auto;
      max-height: 85vh;
      width: 904px;
      max-width: 776px;
    }
  `,
  CATEGORIES: css`
    right: 80px;
    top: 55%;
    border-radius: 24px;
    border-bottom: 24px solid white;
    transform: translate(0%, 0%);
    height: 60vh;
    padding: 0px;
    width: 912px;
    margin-top: 42px;

    @media (min-width: ${breakpoints.wideDesktop}px) {
      margin-top: 7px;
      margin-right: 480px;
      top: 56px !important;
    }
  `,
}
